import React, { FunctionComponent, useMemo } from 'react';

import { BannerTitle as BannerTitleType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import { graphql } from 'gatsby';
import Buttons from '../../Buttons';
import Title from './Title';

export const BannerTitleFragment = graphql`
  fragment BannerTitleFragment on SanityBannerTitle {
    title {
      title
      level
    }
    variant {
      variant
    }
    ctas {
      ...CtaFragment
    }
  }
`;

const BannerTitle: FunctionComponent<BannerTitleType> = (props) => {
  const { ctas = [] } = props;
  const { title, level = 'h2' } = props.title || {};

  const padding = useMemo(() => {
    if (ctas?.length && !title) {
      return { xs: 4, md: [4, 8] };
    }
    return { xs: [8, 4], md: 8 };
  }, [ctas, title]);

  const buttonMargin = title && ctas.length ? [4, 0, 0] : 0;

  return (
    <Flex flexDirection="column" alignItems="center" width="100%" padding={padding}>
      <Title title={title} level={level} />
      <Buttons ctas={ctas} margin={buttonMargin} />
    </Flex>
  );
};

export default BannerTitle;
